<template>
  <div>
    <notifications group="success" position="top right" class="mt-32 mr-8">
      <template slot="body" slot-scope="props">
        <div class="successful-notification flex items-center p-5 mb-5">
          <svg
            class="mr-3"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="white" />
            <path
              d="M18 7.5L9.75 15.75L6 12"
              stroke="#16BA62"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <p class="font-bold" v-html="props.item.text"></p>
        </div>
      </template>
    </notifications>
    <notifications group="error" position="top right" class="mt-32 mr-8">
      <template slot="body" slot-scope="props">
        <div class="error-notification flex items-center p-5 mb-5">
          <svg
            class="mr-2"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="24" height="24" fill="#F24040" />
            <circle cx="12" cy="12" r="12" fill="white" />
            <path
              d="M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5Z"
              stroke="#F24040"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 15H12.0075"
              stroke="#F24040"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 9V12"
              stroke="#F24040"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <p class="font-bold" v-html="props.item.text"></p>
        </div>
      </template>
    </notifications>
    <notifications group="tertiary" position="top right" class="mt-32 mr-8">
      <template slot="body" slot-scope="props">
        <div class="tertiary-notification flex items-center p-5 mb-5">
          <svg
            class="mr-2"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="white" />
            <path
              d="M16.5 9C16.5 7.80653 16.0259 6.66193 15.182 5.81802C14.3381 4.97411 13.1935 4.5 12 4.5C10.8065 4.5 9.66193 4.97411 8.81802 5.81802C7.97411 6.66193 7.5 7.80653 7.5 9C7.5 14.25 5.25 15.75 5.25 15.75H18.75C18.75 15.75 16.5 14.25 16.5 9Z"
              stroke="#0057EA"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.2975 18.75C13.1657 18.9773 12.9764 19.166 12.7487 19.2971C12.521 19.4283 12.2628 19.4973 12 19.4973C11.7372 19.4973 11.4791 19.4283 11.2513 19.2971C11.0236 19.166 10.8344 18.9773 10.7025 18.75"
              stroke="#0057EA"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <p class="font-bold" v-html="props.item.text"></p>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.tertiary-notification,
.error-notification,
.successful-notification {
  min-height: 60px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  @apply text-white;
}

.tertiary-notification {
  background: #0057ea;
}

.error-notification {
  background: #f24040;
}

.successful-notification {
  background: #16ba62;
}
</style>
